import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M10.2675 5C11.0373 3.66667 12.9618 3.66667 13.7316 5L20.6598 17C21.4296 18.3333 20.4673 20 18.9277 20H5.07134C3.53174 20 2.56949 18.3333 3.33929 17L10.2675 5ZM10.9995 9C10.9995 8.44771 11.4473 8 11.9995 8C12.5518 8 12.9995 8.44771 12.9995 9V14C12.9995 14.5523 12.5518 15 11.9995 15C11.4473 15 10.9995 14.5523 10.9995 14V9ZM11.9995 16C11.4473 16 10.9995 16.4477 10.9995 17C10.9995 17.5523 11.4473 18 11.9995 18C12.5518 18 12.9995 17.5523 12.9995 17C12.9995 16.4477 12.5518 16 11.9995 16Z"
            fill="white"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;